var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 475,
    viewBox: "0 0 658 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2897 159.599C156.387 159.599 227.804 88.2234 227.804 0.176453C227.804 -87.8704 156.387 -159.247 68.2897 -159.247C-19.8074 -159.247 -91.2241 -87.8704 -91.2241 0.176453C-91.2241 88.2234 -19.8074 159.599 68.2897 159.599Z",
    fill: "#F87FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2898 -153.455C153.062 -153.455 222.028 -84.5284 222.028 0.19577C222.028 84.9199 153.062 153.846 68.2898 153.846C-16.4826 153.846 -85.448 84.9199 -85.448 0.19577C-85.448 -84.5284 -16.4634 -153.455 68.2898 -153.455ZM68.2898 -165C-22.9902 -165 -97 -91.0515 -97 0.19577C-97 91.4431 -23.0095 165.391 68.2898 165.391C159.589 165.391 233.58 91.4431 233.58 0.19577C233.58 -91.0515 159.589 -165 68.2898 -165Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M507.833 69.7787L480.455 54V85.5767L507.833 69.7787ZM507.833 69.7787L480.455 54V85.5767L507.833 69.7787Z",
    stroke: "#344A77",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M469.596 69.7787L442.237 54V85.5767L469.596 69.7787ZM469.596 69.7787L442.237 54V85.5767",
    stroke: "#344A77",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M431.378 69.7787L404 54V85.5767L431.378 69.7787ZM431.378 69.7787L404 54V85.5767L431.378 69.7787Z",
    stroke: "#344A77",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M657.509 69.7787L630.13 54V85.5767L657.509 69.7787L630.13 54V85.5767L657.509 69.7787Z",
    fill: "#F87FAA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M581.054 69.7787L553.695 54V85.5767L581.054 69.7787L553.695 54V85.5767L581.054 69.7787Z",
    fill: "#F87FAA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4865 312.827C105.719 268.286 75.4543 226.318 30.8877 219.089C-13.679 211.86 -55.6708 242.108 -62.9037 286.649C-70.1366 331.191 -39.8716 373.158 4.69507 380.387C49.2617 387.616 91.2536 357.368 98.4865 312.827Z",
    stroke: "#344A77",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0669 474.411L45.0669 431L-291 431V474.411L45.0669 474.411Z",
    fill: "#344A77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.376196fbec147bc6fca86a8b32ceceea.svg";
export { ForwardRef as ReactComponent };